import { F as e, g as t, i as n, m as r, w as i } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { t as a } from "./i18n-lite-BcmwMblk.js";
import { n as o, r as s, t as c } from "./normalize-props-DNjMoRjC.js";
import { a as l, c as u, i as d, n as f, o as p, r as m, s as h, t as g } from "./nl-De_DKoGY.js";
import { t as _ } from "./PixMailMessage.ce-CiBuIIar.js";
//#endregion
//#region src/webcomponents/template-mail/TemplateMail.ce.vue
var v = /* @__PURE__ */ i({
	__name: "TemplateMail.ce",
	props: {
		titleLevel: { type: Number },
		subject: { type: String },
		mailAddress: { type: String },
		avatarColor: { type: String },
		expeditor: { type: String },
		time: { type: Object },
		content: { type: String },
		previousMail: { type: Object }
	},
	setup(n) {
		let i = n, a = r(() => {
			if (i.previousMail) return {
				sender: { name: i.previousMail.name },
				time: i.previousMail.time,
				body: i.previousMail.content
			};
		}), o = r(() => ({
			subject: i.subject,
			sender: {
				name: i.expeditor,
				address: i.mailAddress,
				avatarColor: i.avatarColor
			},
			time: i.time,
			body: i.content,
			previousMail: a.value
		})), s = {
			reply: "disabled",
			forward: "disabled",
			menu: "disabled",
			return: "hidden"
		};
		return (r, i) => (e(), t(_, {
			"title-level": n.titleLevel,
			mail: o.value,
			actions: s
		}, null, 8, ["title-level", "mail"]));
	}
});
//#endregion
//#region src/webcomponents/template-mail/template-mail.ce.js
a.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"../pix-mail-message/locales/de-AT.json": u,
	"../pix-mail-message/locales/en.json": h,
	"../pix-mail-message/locales/es-419.json": p,
	"../pix-mail-message/locales/es.json": l,
	"../pix-mail-message/locales/fr-BE.json": d,
	"../pix-mail-message/locales/fr.json": m,
	"../pix-mail-message/locales/it.json": f,
	"../pix-mail-message/locales/nl.json": g
}));
var y = n(v, { configureApp(e) {
	a.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(a);
} });
y.prototype.normalizeProps = (e) => ({
	...e,
	titleLevel: c(e.titleLevel),
	avatarColor: s(e.avatarColor),
	previousMail: o(e.previousMail)
}), window.customElements.define("template-mail", y);
//#endregion
